import { useState } from 'react';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { type CplatApiResponse, type UserData } from '@/types/api';
import useWebview from '@/hooks/V3/useWebview';
import { useToast } from '@/hooks/V3/useToast';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import NewsShareButton from './NewsShareButton';
import NewsBell from '@/assets/icons/V3/NewsBell_1.svg?react';
import { Button } from '@/components/V3/Button';
import { setUser } from '@/redux/userSlice';

const PushNotAllowedArea = () => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const { mutate: setUserInfo } = usePost(CPLAT_API_ROUTES.setUserInfo);
  const { mutate: getUserInfo } = usePost(CPLAT_API_ROUTES.getUserInfo);
  const { postMessage } = useWebview();
  const { showToast } = useToast();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGetUserInfo = () => {
    getUserInfo(
      { cplatToken: user.CplatToken },
      {
        onSuccess(res) {
          const { data, code } = res.data as CplatApiResponse<UserData[]>;
          if (code === '200') {
            const updatedUser = data[0];
            dispatch(setUser(updatedUser));

            if (updatedUser.NewsBriefingAlertYn === 'Y') {
              showToast('success', '알림 설정이 완료되었어요');

              // 앱에 유저 정보 갱신 요청
              postMessage({
                action: 'callApi',
                data: 'getUserInfo',
              });
            } else {
              showToast('warning', '알림 설정에 실패했어요. 다시 시도해주세요.');
            }
          } else {
            showToast('warning', '유저 정보를 불러오는 데 실패했어요.');
          }
          setIsSubmitting(false);
        },
        onError(error) {
          console.error(error);
          showToast('warning', '유저 정보를 불러오는 중 오류가 발생했어요.');
          setIsSubmitting(false);
        },
      },
    );
  };

  const handleAllowPush = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    setUserInfo(
      {
        ...user,
        NewsBriefingAlertYn: 'Y',
      },
      {
        onSuccess(res) {
          const { code } = res.data as CplatApiResponse<UserData[]>;
          if (code === '200') {
            handleGetUserInfo(); // ✅ 성공 여부는 여기서 판단
          } else {
            showToast('warning', '알림 설정에 실패했어요. 다시 시도해주세요.');
            setIsSubmitting(false);
          }
        },
        onError(error) {
          console.error(error);
          showToast('warning', '알림 설정 중 오류가 발생했어요.');
          setIsSubmitting(false);
        },
      },
    );
  };

  return (
    <div className="flex w-full items-center justify-center gap-[10px]">
      <NewsShareButton variant="Solid" />
      <Button
        variant="Secondary"
        onClick={handleAllowPush}
        disabled={isSubmitting}
        className="flex h-[26px] w-fit items-center gap-[2px] rounded-[8px] px-[8px] py-[5px] Body5M14"
      >
        매일 아침 8시 알림받기
        <NewsBell />
      </Button>
    </div>
  );
};

export default PushNotAllowedArea;
